import React from 'react'
function Team() {
    return ( 
        <div className='container mt-3'>
            <div className='row'>
                <h1>People</h1>
            </div>
            <div className='row'>
                <div className='col'>
                    <img src="media/images/ohoto.jpg" alt="team1" className='img-fluid rounded-circle' />
                </div>
                <div className='col'>
                    <p>
                        Jashandeep Singh founded Zerodha in 2010 to overcome the hurdles he faced during his decade long stint as a trader.
Today, Zerodha has changed the landscape of the Indian broking industry.

                    </p>
                    <p>
                        He is a member of the SEBI Secondary Market Advisory Committee (SMAC) and the Market Data Advisory Committee (MDAC).

                    </p>
                    <p>
                        Playing basketball is his zen.

                    </p>
                    <p>
                        Connect on <a href="#">Homepage</a> / <a href="#">TradingQnA</a>/<a href="#">Twitter</a>
                    </p>
                </div>
            </div>
        </div>
     );
}

export default Team;